import { useMemo } from 'react';

import { useGetCLAOptions } from 'queries';

import { CLAOption } from '../types';

import { Option } from '../components/shared/ControlledFields/ControlledSelect';

export const createCLAOptions = (data: CLAOption[] | any) => {
  return (
    (data?.map((item) => ({
      value: item.claId,
      label: item.code
    })) as Option[]) ?? []
  );
};

export const useGetOptionsForCLA = (): Option[] | [] => {
  const { data, isError } = useGetCLAOptions();

  return useMemo(() => {
    if (isError) {
      return [];
    }

    return createCLAOptions(data);
  }, [data, isError]);
};
